import { useEffect } from 'react'

const HEADLESS_MODE_CLASS = 'headless-mode'

/**
 * Adds or removes the 'headless-mode' class to document.body based on headlessMode state.
 * This is used to apply special styling when the app is opened in a web view within the mobile app.
 *
 * Should only be used at the root of the app.
 * @see ./src/client/components/App/Routes/Routes.tsx
 */
function useHeadlessModeBodyClass(headlessMode: boolean) {
  useEffect(() => {
    if (headlessMode) {
      document.body.classList.add(HEADLESS_MODE_CLASS)
    } else {
      document.body.classList.remove(HEADLESS_MODE_CLASS)
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove(HEADLESS_MODE_CLASS)
    }
  }, [headlessMode])
}

export default useHeadlessModeBodyClass
